class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    let productRendered = false;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHtml = parsedState.sections?.[section.id];

      if (!target || !sectionHtml) return;

      const innerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (innerHtml === null) return;

      target.innerHTML = innerHtml;
      if (section.id === 'cart-notification-product') productRendered = true;
    });

    if (this.header) this.header.reveal();

    if (productRendered) {
      this.open();
    } else {
      const cartUrl = new URL(window.routes.cart_url, window.location.origin);

      if (window.Shopify?.theme?.id && window.location.hostname.endsWith('.myshopify.com')) {
        cartUrl.searchParams.set('preview_theme_id', window.Shopify.theme.id);
        cartUrl.searchParams.set('_fd', '0');
        cartUrl.searchParams.set('pb', '0');
      }

      window.location.assign(cartUrl.toString());
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const section = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return section ? section.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
